import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Room} from '../../../../../+rooms/shared/models/room.class';
import {RoomService} from '../../../../../+rooms/shared/services/room/room.service';
import {StorageService} from '../../../../../../../shared/services/storage/storage.service';
import {MOMENT_TOKEN} from '../../../../../../shared/shared.module';
import {EventCalendar} from '../../models/event-calendar.model';
import {EventService} from '../../providers/event.service';
import {DialogAddResaComponent} from '../dialog-add-resa/dialog-add-resa.component';
import { DialogConfirmComponent } from 'src/app/+home/shared/components/dialog-confirm/dialog-confirm.component';

@Component({
  selector: 'app-dialog-see-event-details',
  templateUrl: './dialog-see-event-details.component.html',
  styleUrls: ['./dialog-see-event-details.component.scss']
})
export class DialogSeeEventDetailsComponent implements OnInit {
  public event: EventCalendar;
  public room: Room;
  public loadingRoom: boolean;
  public loadingPage: boolean;
  public ticketToken: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogSeeEventDetailsComponent>,
    private dialog: MatDialog,
    private roomService: RoomService,
    private storage: StorageService,
    private eventService: EventService,
    @Inject(MOMENT_TOKEN) public moment
  ) {
  }

  ngOnInit() {
    this.loadingRoom = false;
    this.loadingPage = false;
    this.event = <EventCalendar>this.data.event;

    this.loadRoom(this.event.idSalle);
  }

  loadRoom(id: number) {
    this.loadingRoom = true;
    this.ticketToken = this.storage.getAsync({key: 'token'});

    this.roomService.loadOneRoom(id).then((res: Room) => {
      this.loadingRoom = false;
      this.room = res;
    });
  }

  edit() {
    const dialogRef = this.dialog.open(DialogAddResaComponent, {
      width: '70%',
      height: '65%',
      data: {
        isEdit: true,
        event: this.event,
        dateWanted: this.event.fromDate
      }
    });

    dialogRef.afterClosed().subscribe((result: EventCalendar) => {
      if (result) {
        this.dialogRef.close({edit: result});
      }
    });
  }

  delete() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '40%',
      height: '20%',
      data: {
        text: 'Souhaitez-vous vraiment supprimer cet évènement ?'
      }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.loadingPage = true;

        this.eventService.deleteEvent(this.event).then(res => {
          this.loadingPage = false;
          this.dialogRef.close({delete: this.event.id});
        });
      }
    });
  }
}
